import { render, staticRenderFns } from "./UnscheduledModelSideMenu.vue?vue&type=template&id=1ab08b4a"
import script from "./UnscheduledModelSideMenu.vue?vue&type=script&lang=js"
export * from "./UnscheduledModelSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports